import { Slider as MuiSlider, styled } from '@mui/material'

export const StyledSlider = styled(MuiSlider)(({ theme }) => ({
  '&.MuiSlider-root': {
    width: 'calc(100% - 75px)',
    paddingBottom: 0,
    margin: '0 12px 0 0',
    boxSizing: 'border-box',
  },
  '& .MuiSlider-mark': {
    width: '4px',
    height: '4px',
    borderRadius: '100%',
    backgroundColor: theme.palette.white,
    border: `1px solid ${theme.palette.gray}`,
    opacity: 1,
  },
  '& .MuiSlider-markActive': {
    width: '6px',
    height: '6px',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '100%',
    border: '1px solid #fff',
  },
  '& .MuiSlider-rail': {
    backgroundColor: '#c4c4c4',
    opacity: 1,
  },
  '&.MuiSlider-rail': {
    height: '1px',
  },
  '& .MuiSlider-thumb': {
    width: '12px',
    height: '12px',
    transform: 'translate(-10%, -50%)',
    boxShadow: 'none',
  },
  '& .MuiSlider-markLabel': {
    color: theme.palette.gray,
    top: 'auto',
    bottom: '25px',
    ...theme.typography.caption1,
    transform: 'translateX(-25%)',
    maxWidth: '50px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}))

interface Props {
  value: number
  onChange: (value: number) => unknown
}

export function Slider({ value, onChange }: Props) {
  return (
    <StyledSlider
      defaultValue={0}
      value={value}
      aria-label="Default"
      valueLabelDisplay="off"
      onChange={(_, v) => onChange(v as number)}
      color="secondary"
    />
  )
}
